import { render, staticRenderFns } from "./ErrorBoundary.vue?vue&type=template&id=0c2ae54e&scoped=true"
import script from "./ErrorBoundary.vue?vue&type=script&lang=js"
export * from "./ErrorBoundary.vue?vue&type=script&lang=js"
import style0 from "./ErrorBoundary.vue?vue&type=style&index=0&id=0c2ae54e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2ae54e",
  null
  
)

export default component.exports